'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

module.exports = {
    /**
     * Copies all the properties of s to r.
     * @method
     * @param {Object} r the augmented object
     * @param {Object} s the object need to augment
     * @param {Boolean|Object} [ov=TRUE] whether overwrite existing property or config.
     * @param {Boolean} [ov.overwrite=TRUE] whether overwrite existing property.
     * @param {String[]|Function} [ov.whitelist] array of white-list properties
     * @param {Boolean}[ov.deep=false] whether recursive mix if encounter object.
     * @param {String[]|Function} [wl] array of white-list properties
     * @param [deep=false] {Boolean} whether recursive mix if encounter object.
     * @return {Object} the augmented object
     *
     * for example:
     *     @example
     *     var t = {};
     *     S.mix({x: {y: 2, z: 4}}, {x: {y: 3, a: t}}, {deep: TRUE}) => {x: {y: 3, z: 4, a: {}}}, a !== t
     *     S.mix({x: {y: 2, z: 4}}, {x: {y: 3, a: t}}, {deep: TRUE, overwrite: false}) => {x: {y: 2, z: 4, a: {}}}, a !== t
     *     S.mix({x: {y: 2, z: 4}}, {x: {y: 3, a: t}}, 1) => {x: {y: 3, a: t}}
     */
    mix: function mix(r, s, ov, wl, deep) {
        var k;
        Array.prototype.slice.call(arguments, 1).forEach(function (source) {
            if (source) {
                for (var prop in source) {
                    if ((k = source[prop]) !== undefined) {
                        r[prop] = k;
                    }
                }
            }
        });
        return r;
    },

    /**
     * Returns a new object containing all of the properties of
     * all the supplied objects. The properties from later objects
     * will overwrite those in earlier objects. Passing in a
     * single object will create a shallow copy of it.
     * @param {...Object} varArgs objects need to be merged
     * @return {Object} the new merged object
     */
    merge: function merge() {
        var args = Array.prototype.slice.call(arguments, 0);
        return this.mix.apply(null, [{}].concat(args));
    },

    isObject: function isObject(obj) {
        return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) == 'object';
    },
    isRegExp: function isRegExp(obj) {
        return obj instanceof RegExp;
    },
    isArray: function isArray(obj) {
        return Object.prototype.toString.call(obj) == '[object Array]';
    },
    isFunction: function isFunction(obj) {
        return obj instanceof Function;
    },
    isString: function isString(obj) {
        return typeof obj == 'string';
    },
    isNumber: function isNumber(obj) {
        return typeof obj == 'number';
    },
    //YYYY-MM-DD hh:mm:ss 形式
    formatDate: function formatDate(dateString) {
        var date = dateString.split(' ')[0];
        var time = dateString.split(' ')[1];

        date = date && date.split('-') || [];
        time = time && time.split(':') || [];

        return new Date(date[0], date[1] - 1, date[2], time[0], time[1], time[2]);
    },
    getMeta: function getMeta(name) {
        var metas = document.querySelectorAll('meta');
        var content;

        Array.prototype.forEach.call(metas, function (meta) {
            if (meta.getAttribute('name') == name) {
                content = meta.getAttribute('content');
                return false;
            }
        });

        return content;
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./components/pipe/util/util.js
 ** module id = 10
 ** module chunks = 0
 **/